module.exports = "../static/media/icon_kiss.e9773d69.png";